import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import {
  Field,
  getFormValues,
  InjectedFormProps,
  reduxForm,
} from "redux-form";
import { SelectField, TextField } from "common-fields";
// import CustomerService from "../../Services/CustomerService";
import { ReactComponent as AddContactIcon } from "../../../images/add-contact.svg";
import { Button } from "reactstrap";
import { AxiosError, AxiosResponse } from "axios";
import "./ManualTodos/manualTodo.scss";
import { toast } from "react-toastify";
import Service from "../../../services";
import { catchError } from "../../../utils/Utils";
import { UserData } from "../../../models/SharedModel";
import FinSpinner from "../../../commonfields/FinSpinner";
import { BankUserContext } from "../../../bankUserContext";
// import { catchError } from "../../Utils/Utils";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IAssignTodoFormProps { }

const AssignTodoForm: React.FC<
  IAssignTodoFormProps & InjectedFormProps<any, any>
> = (props: any) => {
  const service = React.useMemo(() => new Service(), []);
  const [users, setUsers] = useState<any>([]);
  const [loader, setLoader] = useState(false);
  const context = React.useContext(BankUserContext);

  React.useEffect(() => {

    // service.getSMBUsers().then((res: AxiosResponse<any>) => {
    //   if (res?.data?.length > 0) {
    //     setUsers(
    //       res.data.map((each: any) => ({
    //         value: each.userId,
    //         text: `${each.firstName} ${each.lastName}`,
    //       }))
    //     );
    //   }
    // });
    const data = {
      "screen": "ProspectDetails",
      "sections": "getUsers"
    }
    // service.(data).then((response:AxiosResponse<UserData[]>)=>{

    //   if(response.data){
    //     setUsers(
    //       response.data?.map((each: any) => ({
    //               id:each.userId,
    //               value: each.userId,
    //               text: `${each.firstName}`,
    //             }))
    //           )
    //   }

    // }).catch((error:AxiosError)=>{
    //   catchError(error,true);
    // })
    if (!props?.viewTodo) {
      console.log("todo", props?.todo)
      service
        .getAllManualTodoUsers(context?.bankuserDetails?.organization?.orgId, props?.todo.todoTypeId)
        .then((response: any) => {
          const data = response.data.map((element: any) => {
            return {
              text: `${element.firstName + " " + element.lastName}`,
              value: element.userId,
            };
          });
          setUsers(
            (data))
        });
    }
  }, [service]);

  const assignUser = () => {
    setLoader(true);
    const data = {
      "sections": "updateTodo",
      "todoUuid": props.todo.todoUuid,
      "priority": props.todo.priority,
      "status": props.todo.status,
      "assignedTo": props.formValues?.assignTo
    }
    props.updateTodo(data).then((response: AxiosResponse) => {
      toast.success(response.data);
      setLoader(false);
      props.getTodo();

      setTimeout(() => {
        props.toggle();
      }, 2000);
    })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });
    // service
    //   .assignTodo(props.todo.todoUuid)
    //   .then((response: AxiosResponse) => {
    //     toast.success(response.data);
    //     setLoader(false);
    //     props.getTodo();
    //     setTimeout(() => {
    //       props.toggle();
    //     }, 2000);
    //   })
    //   .catch((error: AxiosError) => {
    //     catchError(error, true);
    //     setLoader(false);
    //   });
  };
  const { invalid } = props;

  return (
    <div className="assignTodoForm">
      {loader ? <FinSpinner /> : null}
      <form className="form-group">
        <h4 className="assignTodoFormTitle mb-3">Assign Task</h4>
        <Field
          component={TextField}
          type="text"
          name={"todoDescription"}
          helpText={"todoDescription"}
          disabled={true}
        />
        <div className="assignTo mb-3">
          <Field
            component={SelectField}
            name={"assignTo"}
            label={"Assign To:"}
            helpText={"Assign To"}
            values={users}
            isRequired={true}
          />
        </div>
        <Button disabled={props?.pristine || props?.submitting || props?.invalid} onClick={() => assignUser()}>
          <AddContactIcon /> Assign
        </Button>
      </form>
    </div>
  );
};

export default connect((state: any, props: any) => {
  return {
    initialValues: {
      todoDescription: props?.todo?.todoDescription,
    },
    formValues: getFormValues("AssignTodoForm")(state),
  };
})(
  reduxForm<any, any>({
    form: "AssignTodoForm",
    enableReinitialize: true,
  })(AssignTodoForm)
);
